<script>
import api from '@/api'
import { alertSuccess } from '@/helpers/swal'

export default {
  data() {
    return {
      pagetitle: 'Alert Threshold',
      threshold: {
        thresholdName: '',
        critical: 0,
        warning: 0,
      },
      errors: {
        thresholdName: '',
        critical: '',
        warning: '',
      },
      saveBtnDisabled: false,
    }
  },
  components: {},
  async mounted() {
    // In case of edit role
    const thresholdId = this.$route.params.id
    if (thresholdId) {
      await this.getThresholdData(thresholdId)
    }
  },
  methods: {
    async getThresholdData(thresholdId) {
      await api.get(`/alerts/threshold/${thresholdId}`).then((response) => {
        this.threshold = response.data
      })
    },

    saveThreshold() {
      if (!this.validateRequest()) return

      this.saveBtnDisabled = true
      const data = this.threshold
      this.threshold.id ? this.updateThreshold(data) : this.addThreshold(data)
    },

    addThreshold(data) {
      api
        .post('/alerts/threshold/save', data)
        .then(() => {
          alertSuccess('Threshold added successfully')
          this.$router.push({ name: 'alerts-threshold' })
        })
        .finally(() => {
          this.saveBtnDisabled = false
        })
    },

    updateThreshold(data) {
      api
        .post(`/alerts/threshold/modify/${this.threshold.id}`, data)
        .then(() => {
          alertSuccess('Threshold updated successfully')
          this.$router.push({ name: 'alerts-threshold' })
        })
        .finally(() => {
          this.saveBtnDisabled = false
        })
    },

    validateRequest() {
      let isValid = true
      this.errors = {}
      const { thresholdName, critical, warning } = this.threshold
      if (!thresholdName) {
        this.errors.thresholdName = 'Name field is required'
        isValid = false
      }
      if (!critical) {
        this.errors.critical = 'Critical field is required'
        isValid = false
      }
      if (!warning) {
        this.errors.warning = 'Warning field is required'
        isValid = false
      }
      return isValid
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-xl-6">
      <div class="card">
        <div class="card-header d-flex align-items-center">
          <h4 class="card-title">{{ $route.params.id ? 'Edit threshold' : 'Add New threshold' }}</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="saveThreshold()">
            <div class="row">
              <div class="col-12 mb-3">
                <label for="name-input" class="form-label">Name</label>
                <input type="text" class="form-control" placeholder="Enter name" id="name-input" v-model="threshold.thresholdName" disabled />
                <div v-if="errors.thresholdName" class="invalid-feedback">{{ errors.thresholdName }}</div>
              </div>
              <div class="col-6 mb-3">
                <label for="critical-input" class="form-label">Critical</label>
                <input type="number" class="form-control" id="critical-input" oninput="this.value = this.value.replace(/[^0-9]/g, '')" min="1" v-model="threshold.critical" />
                <div v-if="errors.critical" class="invalid-feedback">{{ errors.critical }}</div>
              </div>
              <div class="col-6 mb-3">
                <label for="warning-input" class="form-label">Warning</label>
                <input type="number" class="form-control" id="warning-input" oninput="this.value = this.value.replace(/[^0-9]/g, '')" min="1" v-model="threshold.warning" />
                <div v-if="errors.warning" class="invalid-feedback">{{ errors.warning }}</div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-7">
              <!-- <router-link to="/alerts/threshold" class="btn btn-light d-inline-flex align-items-center">
                <i class="bx bx-arrow-back font-size-16 me-1"></i>
                Back to List
              </router-link> -->
            </div>
            <div class="col-5 d-flex justify-content-end">
              <button class="btn btn-success d-flex align-items-center" @click.prevent="saveThreshold()" :disabled="saveBtnDisabled">
                <i v-if="!saveBtnDisabled" class="bx bx-check-double font-size-16"></i>
                <i v-else class="bx bx-loader bx-spin font-size-16"></i>
                <span class="ms-1">Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
  </div>
</template>
